import type { PersistedDefaultTabProps } from '@talos/kyoko';
import { getReconMismatchesBlotterDefaultStartDate } from './getReconMismatchesBlotterDefaultStartDate';
import type { ReconMismatchesTabProps } from './ReconMismatches';
import type { BlotterTableReconMismatchesFilter } from './useReconMismatchesFilter';

export const ALL_MISMATCHES_TAB_ID = 'all-mismatches';

export function buildDefaultReconMismatchesTabs(): PersistedDefaultTabProps<ReconMismatchesTabProps>[] {
  return [
    {
      label: 'All',
      id: ALL_MISMATCHES_TAB_ID,
      closable: true,
      editable: true,
      defaultFilter: {
        StartDate: getReconMismatchesBlotterDefaultStartDate(),
      },
    },
  ];
}

export function buildNewReconMismatchTabDefaults(): { defaultFilter: BlotterTableReconMismatchesFilter } {
  return {
    defaultFilter: {
      StartDate: getReconMismatchesBlotterDefaultStartDate(),
    },
  };
}
